import { styled } from "styled-components";

import {
    colorCSS,
    cssColorsFromBackgroundField,
    fontSizes,
    maxWidth,
    minWidth
} from "../../styles";
import { redundantCssFromKebab } from "../../styles/redundant-css";

//style variables
const textColor = colorCSS("N0");

//styled components
export const Footer = styled.footer`
    ${cssColorsFromBackgroundField({ color: "N800" })} section {
        ${redundantCssFromKebab("color", `${textColor}`)}

        span {
            ${redundantCssFromKebab("font-size", `${fontSizes.sm}`)}
        }

        svg {
            ${redundantCssFromKebab("max-width", "125px")}
        }

        a,
        button {
            ${redundantCssFromKebab("color", `${textColor}`)}
            ${redundantCssFromKebab("text-decoration", "none")}

            &:hover {
                ${redundantCssFromKebab("color", `${textColor}`)}
                ${redundantCssFromKebab("text-decoration", "underline")}
            }
        }

        ul {
            ${redundantCssFromKebab("text-align", "left")}
            ${redundantCssFromKebab("list-style-type", "none")}
            ${redundantCssFromKebab("padding", "0")}
        }
        @media ${maxWidth.lg} {
            form {
                ${redundantCssFromKebab("margin-left", "1rem")}
            }
        }
    }
`;

export const LogoAndLoginContainer = styled.div`
    ${redundantCssFromKebab("margin", "1.5rem 1rem 0 1rem")}
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-wrap", "nowrap")}
    ${redundantCssFromKebab("justify-content", "space-between")}
    ${redundantCssFromKebab("gap", "1.75rem")}

    a {
        ${redundantCssFromKebab("padding", "0")}
        ${redundantCssFromKebab("margin", "0")}
    }
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("flex-direction", "column")}
        ${redundantCssFromKebab("align-items", "stretch")}
        ${redundantCssFromKebab("margin", "1rem 1rem 0 0")}
        ${redundantCssFromKebab("gap", "1rem")}
    }
`;

export const TabsList = styled.ul`
    ${redundantCssFromKebab("margin", "0 0 0 1rem")}

    h4,
    p {
        ${redundantCssFromKebab("color", `${textColor}`)}
        ${redundantCssFromKebab("width", "60%")}
        ${redundantCssFromKebab("margin", "0")}
        ${redundantCssFromKebab("padding", "0")}
    }

    div > p {
        ${redundantCssFromKebab("color", `${textColor}`)}
    }

    a {
        ${redundantCssFromKebab("margin", "0")}
        ${redundantCssFromKebab("padding", "0")}
    }

    li {
        ${redundantCssFromKebab(
            "border-bottom",
            `1px solid ${colorCSS("N400")}`
        )}
        ${redundantCssFromKebab("padding", "0 0 1rem 0")}
        ${redundantCssFromKebab("margin", "0 0 1rem 0")}
    }

    li:first-child {
        ${redundantCssFromKebab("border-top", `1px solid ${colorCSS("N400")}`)}
        ${redundantCssFromKebab("margin-top", "1rem")}
        ${redundantCssFromKebab("padding", "1rem 0 1rem 0")}
    }

    li:last-child {
        ${redundantCssFromKebab("margin", "0")}
    }
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("display", "flex")}
        ${redundantCssFromKebab("flex-wrap", "wrap")}
        ${redundantCssFromKebab("margin", "0")}

        h4,
        p {
            ${redundantCssFromKebab("width", "100%")}
        }

        a {
            ${redundantCssFromKebab("padding", "1rem")}
            ${redundantCssFromKebab("gap", "0.25rem")}
            ${redundantCssFromKebab("height", "100%")}

            &:hover {
                ${redundantCssFromKebab("text-decoration", "none !important")}
                ${redundantCssFromKebab(
                    "background-color",
                    `${colorCSS("N600")}`
                )}
            }
        }

        li {
            ${redundantCssFromKebab("border", "none")}
            ${redundantCssFromKebab("padding", "0")}
            ${redundantCssFromKebab("margin", "0")}
            ${redundantCssFromKebab("width", "25%")}
        }

        li:first-child {
            ${redundantCssFromKebab("border", "none")}
            ${redundantCssFromKebab("padding", "0")}
            ${redundantCssFromKebab("margin", "0")}
        }
    }
`;

export const Divider = styled.div`
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("border-top", `1px solid ${colorCSS("N400")}`)}
        ${redundantCssFromKebab("width", "98%")}
        ${redundantCssFromKebab("margin", "0 auto")}
    }
`;

export const SubNav = styled.nav<{ hideLanguageSelector: boolean }>`
    ul {
        li {
            ${redundantCssFromKebab("margin-left", "1rem")}
            a,
            button,
            span {
                ${redundantCssFromKebab("font-size", `${fontSizes.xxs}`)}
            }
        }
    }
    @media ${minWidth.lg} {
        ul {
            ${redundantCssFromKebab("display", "flex")}
            ${redundantCssFromKebab("flex-wrap", "nowrap")}
            li {
                ${redundantCssFromKebab("margin-right", "1.5rem")}
                ${redundantCssFromKebab("margin-left", "0")}
                ${({ hideLanguageSelector }) =>
                    !hideLanguageSelector &&
                    `&:first-child { margin-left: 1rem; }`}
            }
        }
    }
`;

export const SocialNavLinks = styled.div`
    ${redundantCssFromKebab("display", "flex")}
    ${redundantCssFromKebab("flex-wrap", "wrap")}
    ${redundantCssFromKebab("gap", "2rem")}
    ${redundantCssFromKebab("margin", "3rem 1rem 0 1rem")}
    ${redundantCssFromKebab("padding", "0 0 3rem 0")}
    @media ${minWidth.lg} {
        ${redundantCssFromKebab("justify-content", "space-between")}
        ${redundantCssFromKebab("gap", "0")}
        ${redundantCssFromKebab("margin", "0")}
        ${redundantCssFromKebab("padding", "0")}
    }

    a {
        ${redundantCssFromKebab("align-items", "center")}
        ${redundantCssFromKebab("border-radius", "50%")}
        ${redundantCssFromKebab("border", `2px solid ${textColor}`)}
        ${redundantCssFromKebab("display", "flex")}
        ${redundantCssFromKebab("height", "24px")}
        ${redundantCssFromKebab("margin", "0 !important")}
        ${redundantCssFromKebab("width", "24px")}

        svg {
            ${redundantCssFromKebab("height", "60%")}
            ${redundantCssFromKebab("margin", "auto !important")}
            ${redundantCssFromKebab("transition", "all 0.15s")}
            ${redundantCssFromKebab("width", "60%")}

            path {
                ${redundantCssFromKebab("fill", `${textColor}`)}
            }
        }

        &:hover {
            svg {
                ${redundantCssFromKebab("height", "50%")}
                ${redundantCssFromKebab("width", "50%")}

                path {
                    ${redundantCssFromKebab("fill", `${textColor}`)}
                }
            }
        }
    }
`;
